import { useMutation } from "@tanstack/react-query";
import { updateTasksV1, updateTasksV2 } from "./tasks.service";

export const useUpdateTasksV2 = () => {
  return useMutation({ mutationFn: updateTasksV2 });
};

export const useUpdateTasksV1 = () => {
  return useMutation({ mutationFn: updateTasksV1 });
};
